/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateShopSettings = /* GraphQL */ `
  subscription OnCreateShopSettings(
    $filter: ModelSubscriptionShopSettingsFilterInput
  ) {
    onCreateShopSettings(filter: $filter) {
      id
      locationId
      currentRO
      settingsJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateShopSettings = /* GraphQL */ `
  subscription OnUpdateShopSettings(
    $filter: ModelSubscriptionShopSettingsFilterInput
  ) {
    onUpdateShopSettings(filter: $filter) {
      id
      locationId
      currentRO
      settingsJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteShopSettings = /* GraphQL */ `
  subscription OnDeleteShopSettings(
    $filter: ModelSubscriptionShopSettingsFilterInput
  ) {
    onDeleteShopSettings(filter: $filter) {
      id
      locationId
      currentRO
      settingsJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBay = /* GraphQL */ `
  subscription OnCreateBay($filter: ModelSubscriptionBayFilterInput) {
    onCreateBay(filter: $filter) {
      id
      locationId
      shopId
      bayNumber
      label
      type
      zone
      x
      y
      width
      height
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBay = /* GraphQL */ `
  subscription OnUpdateBay($filter: ModelSubscriptionBayFilterInput) {
    onUpdateBay(filter: $filter) {
      id
      locationId
      shopId
      bayNumber
      label
      type
      zone
      x
      y
      width
      height
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBay = /* GraphQL */ `
  subscription OnDeleteBay($filter: ModelSubscriptionBayFilterInput) {
    onDeleteBay(filter: $filter) {
      id
      locationId
      shopId
      bayNumber
      label
      type
      zone
      x
      y
      width
      height
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTruck = /* GraphQL */ `
  subscription OnCreateTruck($filter: ModelSubscriptionTruckFilterInput) {
    onCreateTruck(filter: $filter) {
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
        __typename
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
        __typename
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
        __typename
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
        __typename
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      laborType
      customerType
      shopId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
        __typename
      }
      estimates {
        id
        truckId
        roNumber
        status
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        createdBy
        createdAt
        updatedAt
        version
        __typename
      }
      customerId
      unitId
      poNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTruck = /* GraphQL */ `
  subscription OnUpdateTruck($filter: ModelSubscriptionTruckFilterInput) {
    onUpdateTruck(filter: $filter) {
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
        __typename
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
        __typename
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
        __typename
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
        __typename
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      laborType
      customerType
      shopId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
        __typename
      }
      estimates {
        id
        truckId
        roNumber
        status
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        createdBy
        createdAt
        updatedAt
        version
        __typename
      }
      customerId
      unitId
      poNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTruck = /* GraphQL */ `
  subscription OnDeleteTruck($filter: ModelSubscriptionTruckFilterInput) {
    onDeleteTruck(filter: $filter) {
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
        __typename
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
        __typename
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
        __typename
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
        __typename
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      laborType
      customerType
      shopId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
        __typename
      }
      estimates {
        id
        truckId
        roNumber
        status
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        createdBy
        createdAt
        updatedAt
        version
        __typename
      }
      customerId
      unitId
      poNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onCreateCustomer(filter: $filter) {
      id
      shopId
      name
      contactPerson
      phone
      email
      customerType
      fleetId
      partsHandling
      paymentTermsDays
      warranty
      notes
      poRequired
      creditHold
      creditHoldNote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onUpdateCustomer(filter: $filter) {
      id
      shopId
      name
      contactPerson
      phone
      email
      customerType
      fleetId
      partsHandling
      paymentTermsDays
      warranty
      notes
      poRequired
      creditHold
      creditHoldNote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onDeleteCustomer(filter: $filter) {
      id
      shopId
      name
      contactPerson
      phone
      email
      customerType
      fleetId
      partsHandling
      paymentTermsDays
      warranty
      notes
      poRequired
      creditHold
      creditHoldNote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUnit = /* GraphQL */ `
  subscription OnCreateUnit($filter: ModelSubscriptionUnitFilterInput) {
    onCreateUnit(filter: $filter) {
      id
      shopId
      customerId
      vin
      unitNumber
      year
      make
      model
      mileage
      hours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUnit = /* GraphQL */ `
  subscription OnUpdateUnit($filter: ModelSubscriptionUnitFilterInput) {
    onUpdateUnit(filter: $filter) {
      id
      shopId
      customerId
      vin
      unitNumber
      year
      make
      model
      mileage
      hours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUnit = /* GraphQL */ `
  subscription OnDeleteUnit($filter: ModelSubscriptionUnitFilterInput) {
    onDeleteUnit(filter: $filter) {
      id
      shopId
      customerId
      vin
      unitNumber
      year
      make
      model
      mileage
      hours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateColumnTimeout = /* GraphQL */ `
  subscription OnCreateColumnTimeout(
    $filter: ModelSubscriptionColumnTimeoutFilterInput
  ) {
    onCreateColumnTimeout(filter: $filter) {
      id
      columnId
      limit
      warning
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateColumnTimeout = /* GraphQL */ `
  subscription OnUpdateColumnTimeout(
    $filter: ModelSubscriptionColumnTimeoutFilterInput
  ) {
    onUpdateColumnTimeout(filter: $filter) {
      id
      columnId
      limit
      warning
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteColumnTimeout = /* GraphQL */ `
  subscription OnDeleteColumnTimeout(
    $filter: ModelSubscriptionColumnTimeoutFilterInput
  ) {
    onDeleteColumnTimeout(filter: $filter) {
      id
      columnId
      limit
      warning
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTechnician = /* GraphQL */ `
  subscription OnCreateTechnician(
    $filter: ModelSubscriptionTechnicianFilterInput
  ) {
    onCreateTechnician(filter: $filter) {
      id
      locationId
      name
      number
      specialties
      active
      currentLoad
      completionRate
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTechnician = /* GraphQL */ `
  subscription OnUpdateTechnician(
    $filter: ModelSubscriptionTechnicianFilterInput
  ) {
    onUpdateTechnician(filter: $filter) {
      id
      locationId
      name
      number
      specialties
      active
      currentLoad
      completionRate
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTechnician = /* GraphQL */ `
  subscription OnDeleteTechnician(
    $filter: ModelSubscriptionTechnicianFilterInput
  ) {
    onDeleteTechnician(filter: $filter) {
      id
      locationId
      name
      number
      specialties
      active
      currentLoad
      completionRate
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCustomerCheckIn = /* GraphQL */ `
  subscription OnCreateCustomerCheckIn(
    $filter: ModelSubscriptionCustomerCheckInFilterInput
  ) {
    onCreateCustomerCheckIn(filter: $filter) {
      id
      locationId
      companyName
      contactPerson
      phone
      email
      serviceReason
      partsHandling
      signatureImage
      agreementConfirmed
      status
      timestamp
      createdAt
      updatedAt
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleVin
      vehicleMileage
      vehicleEngineHours
      vehicleFaults
      __typename
    }
  }
`;
export const onUpdateCustomerCheckIn = /* GraphQL */ `
  subscription OnUpdateCustomerCheckIn(
    $filter: ModelSubscriptionCustomerCheckInFilterInput
  ) {
    onUpdateCustomerCheckIn(filter: $filter) {
      id
      locationId
      companyName
      contactPerson
      phone
      email
      serviceReason
      partsHandling
      signatureImage
      agreementConfirmed
      status
      timestamp
      createdAt
      updatedAt
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleVin
      vehicleMileage
      vehicleEngineHours
      vehicleFaults
      __typename
    }
  }
`;
export const onDeleteCustomerCheckIn = /* GraphQL */ `
  subscription OnDeleteCustomerCheckIn(
    $filter: ModelSubscriptionCustomerCheckInFilterInput
  ) {
    onDeleteCustomerCheckIn(filter: $filter) {
      id
      locationId
      companyName
      contactPerson
      phone
      email
      serviceReason
      partsHandling
      signatureImage
      agreementConfirmed
      status
      timestamp
      createdAt
      updatedAt
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleVin
      vehicleMileage
      vehicleEngineHours
      vehicleFaults
      __typename
    }
  }
`;
export const onCreateRepairEvent = /* GraphQL */ `
  subscription OnCreateRepairEvent(
    $filter: ModelSubscriptionRepairEventFilterInput
  ) {
    onCreateRepairEvent(filter: $filter) {
      id
      locationId
      shopId
      roNumber
      sourceTruckId
      vin
      unitNumber
      engineFamily
      make
      model
      year
      classificationId
      quotedLaborHours
      actualLaborHours
      completedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRepairEvent = /* GraphQL */ `
  subscription OnUpdateRepairEvent(
    $filter: ModelSubscriptionRepairEventFilterInput
  ) {
    onUpdateRepairEvent(filter: $filter) {
      id
      locationId
      shopId
      roNumber
      sourceTruckId
      vin
      unitNumber
      engineFamily
      make
      model
      year
      classificationId
      quotedLaborHours
      actualLaborHours
      completedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRepairEvent = /* GraphQL */ `
  subscription OnDeleteRepairEvent(
    $filter: ModelSubscriptionRepairEventFilterInput
  ) {
    onDeleteRepairEvent(filter: $filter) {
      id
      locationId
      shopId
      roNumber
      sourceTruckId
      vin
      unitNumber
      engineFamily
      make
      model
      year
      classificationId
      quotedLaborHours
      actualLaborHours
      completedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLaborAggregate = /* GraphQL */ `
  subscription OnCreateLaborAggregate(
    $filter: ModelSubscriptionLaborAggregateFilterInput
  ) {
    onCreateLaborAggregate(filter: $filter) {
      id
      scope
      scopeId
      classificationId
      count
      sumHours
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const onUpdateLaborAggregate = /* GraphQL */ `
  subscription OnUpdateLaborAggregate(
    $filter: ModelSubscriptionLaborAggregateFilterInput
  ) {
    onUpdateLaborAggregate(filter: $filter) {
      id
      scope
      scopeId
      classificationId
      count
      sumHours
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const onDeleteLaborAggregate = /* GraphQL */ `
  subscription OnDeleteLaborAggregate(
    $filter: ModelSubscriptionLaborAggregateFilterInput
  ) {
    onDeleteLaborAggregate(filter: $filter) {
      id
      scope
      scopeId
      classificationId
      count
      sumHours
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const onCreateOperationEvent = /* GraphQL */ `
  subscription OnCreateOperationEvent(
    $filter: ModelSubscriptionOperationEventFilterInput
  ) {
    onCreateOperationEvent(filter: $filter) {
      id
      eventType
      timestamp
      locationId
      assetId
      workOrderId
      technicianId
      userId
      previousStatus
      newStatus
      note
      relatedPhotoIds
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOperationEvent = /* GraphQL */ `
  subscription OnUpdateOperationEvent(
    $filter: ModelSubscriptionOperationEventFilterInput
  ) {
    onUpdateOperationEvent(filter: $filter) {
      id
      eventType
      timestamp
      locationId
      assetId
      workOrderId
      technicianId
      userId
      previousStatus
      newStatus
      note
      relatedPhotoIds
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOperationEvent = /* GraphQL */ `
  subscription OnDeleteOperationEvent(
    $filter: ModelSubscriptionOperationEventFilterInput
  ) {
    onDeleteOperationEvent(filter: $filter) {
      id
      eventType
      timestamp
      locationId
      assetId
      workOrderId
      technicianId
      userId
      previousStatus
      newStatus
      note
      relatedPhotoIds
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRoadServiceCall = /* GraphQL */ `
  subscription OnCreateRoadServiceCall(
    $filter: ModelSubscriptionRoadServiceCallFilterInput
  ) {
    onCreateRoadServiceCall(filter: $filter) {
      id
      customerId
      assetId
      locationId
      customerName
      companyName
      contactName
      callbackPhone
      unitNumber
      vin
      complaint
      roadServiceAddress
      destinationLatitude
      destinationLongitude
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleColor
      priority
      assignedTechnicianId
      assignedServiceTruckId
      status
      workOrderId
      dispatchedAt
      travelStartedAt
      arrivedAt
      workStartedAt
      completedAt
      cancelledAt
      acceptedAt
      acceptedByTechnicianId
      holdStartedAt
      currentHoldReason
      currentHoldNote
      holdResumeStatus
      returnedAt
      odometerOut
      odometerReturn
      billedMiles
      billedHours
      billingNote
      customerSignatureUrl
      locationRequestToken
      locationRequestPhone
      locationRequestedAt
      locationReceivedAt
      locationRequestStatus
      locationSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRoadServiceCall = /* GraphQL */ `
  subscription OnUpdateRoadServiceCall(
    $filter: ModelSubscriptionRoadServiceCallFilterInput
  ) {
    onUpdateRoadServiceCall(filter: $filter) {
      id
      customerId
      assetId
      locationId
      customerName
      companyName
      contactName
      callbackPhone
      unitNumber
      vin
      complaint
      roadServiceAddress
      destinationLatitude
      destinationLongitude
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleColor
      priority
      assignedTechnicianId
      assignedServiceTruckId
      status
      workOrderId
      dispatchedAt
      travelStartedAt
      arrivedAt
      workStartedAt
      completedAt
      cancelledAt
      acceptedAt
      acceptedByTechnicianId
      holdStartedAt
      currentHoldReason
      currentHoldNote
      holdResumeStatus
      returnedAt
      odometerOut
      odometerReturn
      billedMiles
      billedHours
      billingNote
      customerSignatureUrl
      locationRequestToken
      locationRequestPhone
      locationRequestedAt
      locationReceivedAt
      locationRequestStatus
      locationSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRoadServiceCall = /* GraphQL */ `
  subscription OnDeleteRoadServiceCall(
    $filter: ModelSubscriptionRoadServiceCallFilterInput
  ) {
    onDeleteRoadServiceCall(filter: $filter) {
      id
      customerId
      assetId
      locationId
      customerName
      companyName
      contactName
      callbackPhone
      unitNumber
      vin
      complaint
      roadServiceAddress
      destinationLatitude
      destinationLongitude
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleColor
      priority
      assignedTechnicianId
      assignedServiceTruckId
      status
      workOrderId
      dispatchedAt
      travelStartedAt
      arrivedAt
      workStartedAt
      completedAt
      cancelledAt
      acceptedAt
      acceptedByTechnicianId
      holdStartedAt
      currentHoldReason
      currentHoldNote
      holdResumeStatus
      returnedAt
      odometerOut
      odometerReturn
      billedMiles
      billedHours
      billingNote
      customerSignatureUrl
      locationRequestToken
      locationRequestPhone
      locationRequestedAt
      locationReceivedAt
      locationRequestStatus
      locationSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRoadServiceStatusEvent = /* GraphQL */ `
  subscription OnCreateRoadServiceStatusEvent(
    $filter: ModelSubscriptionRoadServiceStatusEventFilterInput
  ) {
    onCreateRoadServiceStatusEvent(filter: $filter) {
      id
      roadServiceCallId
      locationId
      status
      fromStatus
      at
      technicianId
      techNumber
      techName
      holdReason
      holdNote
      resumeStatus
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRoadServiceStatusEvent = /* GraphQL */ `
  subscription OnUpdateRoadServiceStatusEvent(
    $filter: ModelSubscriptionRoadServiceStatusEventFilterInput
  ) {
    onUpdateRoadServiceStatusEvent(filter: $filter) {
      id
      roadServiceCallId
      locationId
      status
      fromStatus
      at
      technicianId
      techNumber
      techName
      holdReason
      holdNote
      resumeStatus
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRoadServiceStatusEvent = /* GraphQL */ `
  subscription OnDeleteRoadServiceStatusEvent(
    $filter: ModelSubscriptionRoadServiceStatusEventFilterInput
  ) {
    onDeleteRoadServiceStatusEvent(filter: $filter) {
      id
      roadServiceCallId
      locationId
      status
      fromStatus
      at
      technicianId
      techNumber
      techName
      holdReason
      holdNote
      resumeStatus
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTimeEntry = /* GraphQL */ `
  subscription OnCreateTimeEntry(
    $filter: ModelSubscriptionTimeEntryFilterInput
  ) {
    onCreateTimeEntry(filter: $filter) {
      id
      locationId
      workOrderId
      roadServiceCallId
      technicianId
      techNumber
      techName
      kind
      startedAt
      endedAt
      seconds
      billedAt
      billedEstimateId
      note
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTimeEntry = /* GraphQL */ `
  subscription OnUpdateTimeEntry(
    $filter: ModelSubscriptionTimeEntryFilterInput
  ) {
    onUpdateTimeEntry(filter: $filter) {
      id
      locationId
      workOrderId
      roadServiceCallId
      technicianId
      techNumber
      techName
      kind
      startedAt
      endedAt
      seconds
      billedAt
      billedEstimateId
      note
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTimeEntry = /* GraphQL */ `
  subscription OnDeleteTimeEntry(
    $filter: ModelSubscriptionTimeEntryFilterInput
  ) {
    onDeleteTimeEntry(filter: $filter) {
      id
      locationId
      workOrderId
      roadServiceCallId
      technicianId
      techNumber
      techName
      kind
      startedAt
      endedAt
      seconds
      billedAt
      billedEstimateId
      note
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTechnicianLocation = /* GraphQL */ `
  subscription OnCreateTechnicianLocation(
    $filter: ModelSubscriptionTechnicianLocationFilterInput
  ) {
    onCreateTechnicianLocation(filter: $filter) {
      id
      technicianId
      userId
      locationId
      latitude
      longitude
      accuracy
      heading
      speed
      timestamp
      source
      activeRoadServiceCallId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTechnicianLocation = /* GraphQL */ `
  subscription OnUpdateTechnicianLocation(
    $filter: ModelSubscriptionTechnicianLocationFilterInput
  ) {
    onUpdateTechnicianLocation(filter: $filter) {
      id
      technicianId
      userId
      locationId
      latitude
      longitude
      accuracy
      heading
      speed
      timestamp
      source
      activeRoadServiceCallId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTechnicianLocation = /* GraphQL */ `
  subscription OnDeleteTechnicianLocation(
    $filter: ModelSubscriptionTechnicianLocationFilterInput
  ) {
    onDeleteTechnicianLocation(filter: $filter) {
      id
      technicianId
      userId
      locationId
      latitude
      longitude
      accuracy
      heading
      speed
      timestamp
      source
      activeRoadServiceCallId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
